<template>
  <div class="soar-container">
    <div class="w-full my-6 flex flex-col">
      <div class="border-b border-brand-gray-350 py-3">
        <h2 class="text-xl text-gray-500 font-normal mx-3">
          {{ $t('documents') }}
        </h2>
      </div>
      <div class="w-full mt-3 flex items-center gap-3">
        <DocumentCard
          :emiratesID="emiratesID"
          :emirateInfoList="emirateInfoList"
          :emiratesIDPortrait="emiratesIDPortrait"
        />
        <DocumentCard
          :emiratesID="residency"
          :emirateInfoList="residencyInfoList"
          :emiratesIDPortrait="residencyEmiratesIDPortrait"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import apiHelperService from '@/services'
import lookups from '@/assets/json/clientLookups.json'
import { useRoute, useRouter } from 'vue-router'
import { DateTime } from 'luxon'

import DocumentCard from '@/views/establishment/sponsored/DocumentCard.vue'

const emiratesID = ref()
const residency = ref()
const emiratesIDPortrait = ref()
const residencyEmiratesIDPortrait = ref()
const emirateInfoList = ref([])
const residencyInfoList = ref([])

const route = useRoute()
const router = useRouter()
const i18n = useI18n()

const defaultDateFormat = 'yyyy/MM/dd'

const formatDate = (val) => {
  return val ? DateTime.fromISO(val).toFormat(defaultDateFormat) : ''
}

const emiratesIdDocumentInfo = async (isResidency) => {
  const { residency, eID } = lookups.myDocumentWalletType
  return await apiHelperService.get(`/api/printUAEDocuments/establishment/getEmployeeDocument`, {
    params: {
      documentTypeId: isResidency ? residency : eID,
      unifiedNumber: route.query.employeeUN,
      childEstablishmentId: route.query.childEstablishmentId
    }
  })
}

const formatInfoList = () => {
  emirateInfoList.value = [
    {
      label: 'fullName',
      value:
        i18n.locale.value == 'ar'
          ? emiratesID.value.arabicFullName
          : emiratesID.value.englishFullName
    },
    {
      label: 'identityNumber',
      value: emiratesID.value.identityNumber
    },
    {
      label: 'nationality',
      value: emiratesID.value.nationality?.text
    },
    {
      label: 'dateOfBirth',
      value: formatDate(emiratesID.value.dateOfBirth)
    },
    {
      label: 'policyIssueDate',
      value: formatDate(emiratesID.value.identityIssueDate)
    }
  ]
}

const formatResidencyInfoList = () => {
  residencyInfoList.value = [
    {
      label: 'fullName',
      value:
        i18n.locale.value == 'ar'
          ? residency.value.personName?.fullArabicName
          : residency.value.personName?.fullEnglishName
    },
    {
      label: 'nationality',
      value:
        i18n.locale.value == 'ar'
          ? residency.value.nationality?.arDesc
          : residency.value.nationality?.enDesc
    },
    {
      label: 'dateOfBirth',
      value: formatDate(emiratesID.value.dateOfBirth)
    },
    {
      label: 'policyIssueDate',
      value: formatDate(residency.value.immigrationFile?.issuDate)
    },
    {
      label: 'policyExpiryDate',
      value: formatDate(residency.value.immigrationFile?.expiryDate)
    }
  ]
}

onMounted(async () => {
  const res = await emiratesIdDocumentInfo()
  emiratesID.value = res.emiratesID
  formatInfoList()
  if (emiratesID.value.portrait) {
    emiratesIDPortrait.value = `data:image/jpeg;base64,${emiratesID.value.portrait}`
  }

  const residencyRes = await emiratesIdDocumentInfo(true)
  residency.value = residencyRes.residency
  formatResidencyInfoList()
  if (residency.value.portrait) {
    residencyEmiratesIDPortrait.value = `data:image/jpeg;base64,${residency.value.portrait}`
  }
})
</script>
<style scoped lang="scss"></style>
